export class Inquiry {
  email: string
  phone: string
  message: string
  name: string
}
